<template>
  <label
    :title="item?.name"
    class="rrbv-wrapper flex flex-col items-center justify-center rounded-md border border-light-gray p-0 hover:border-gray-over-dark"
    :class="{ activeButton: show && checked }"
    :style="[constrainWidth == true ? 'max-width: 200px;' : '']"
  >
    <!-- <label
      class="container"
      :class="{'text-dark-gray': show && checked}"
    > -->
    <slot />
    <div class="flex flex-col items-center justify-center gap-2">
      <div class="flex h-full w-full items-center justify-center px-8 py-1">
        <div class="flex h-14 w-full items-center justify-center">
          <img
            v-if="item?.logo?.url"
            class="min-w-70px"
            :src="item?.logo?.url"
            :alt="item?.name"
          />
          <span
            v-else
            class="text-sm leading-tight text-dark-blue"
            >{{ item?.name }}</span
          >
        </div>
      </div>
    </div>
    <div class="relative h-0 w-full opacity-0">
      <input
        type="radio"
        :value="value"
        :name="name"
        :checked="show && checked"
        :disabled="disabled"
        @click="handleClick"
      />
      <span class="checkmark" />
    </div>
    <!-- </label> -->
  </label>
</template>

<script>
export default {
  name: 'RoundRadioButtonEld',
  props: {
    item: Object,
    name: String,
    checked: Boolean,
    // subtext: {
    //   type: String,
    //   default: "",
    // },
    customClass: {
      type: String,
      default: '',
    },
    subtextClass: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
    value: [String, Boolean, Number],
    handleClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    constrainWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
/* .container {
  @apply h-full pl-12 text-left text-sm flex items-center text-body-color block relative cursor-pointer;
  height: 60px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
} */

.rrbv-wrapper {
  @apply relative cursor-pointer px-2 py-4 text-center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: white;
}

/* Hide the browser's default checkbox */
.rrbv-wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  @apply absolute bottom-2 left-1/2 h-6 w-6 rounded-full bg-light-gray;
  transform: translate(-50%, -50%);
}

/* When the checkbox is checked, add a yellow background */
.rrbv-wrapper input:checked ~ .checkmark {
  @apply bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.rrbv-wrapper input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.rrbv-wrapper .checkmark:after {
  left: 8px;
  top: 8px;
  width: 8px;
  height: 8px;
  background-color: white;
  border: solid white;
  border-radius: 9999px;
}

.activeButton {
  @apply flex flex-wrap rounded-md border border-yellow-500 bg-white;

  border-color: rgb(248, 198, 23) !important;
  background-color: white !important;
  box-shadow: 2px 4px 0px #f8c617;
  box-shadow:
    0 4px 6px -1px rgba(248, 198, 23, 0.3),
    0 2px 4px -1px rgba(248, 198, 23, 0.06);
}

.h4-style {
  font-size: 18px;
  line-height: 27px;
}

.omnitracs-cls-1 {
  fill: url(#New_Gradient_Swatch_copy_3);
}

.omnitracs-cls-2 {
  fill: #929497;
}

.omnitracs-cls-3 {
  fill: #404041;
}

.omnitracs-cls-4 {
  fill: #6d6e70;
}

.omnitracs .e {
  fill: url(#d);
}

.omnitracs .f {
  fill: #929497;
}

.omnitracs .g {
  fill: #404041;
}

.omnitracs .h {
  fill: #6d6e70;
}

.rand-st0 {
  fill: #000000;
}

.rand-st1 {
  display: none;
}

.rand-st2 {
  display: none;
}

.rand-st3 {
  display: inline;
  fill: none;
  stroke: #2bace2;
  stroke-width: 0.25;
  stroke-miterlimit: 10;
}

.rand-st4 {
  display: inline;
  fill: #2bace2;
}

.rand-st5 {
  display: inline;
}
</style>
